import React from 'react'
import { v4 as uuidv4 } from 'uuid';
import LinkImage from '../../../../components/LinkImage/index.js'

const SingleExperience = (element) => {
    return(
        <div className="experience mt-6">
            <p className="para-text">{element.title}</p>
            <p className="subpara-text">
                {element.company} &nbsp;
                {element.link !== undefined && element.link !== null && element.link !== '' &&
                    <a target="new" href={element.link}>
                        &nbsp;&nbsp;<LinkImage />
                    </a>
                }
            </p>
            <div className="flex-container space-between">
                <p className="subpara-text italicstyling">{element.startDate}{element.endDate !== '' &&  ' - '+ element.endDate}</p>
                <p className="subpara-text italicstyling">{element.place}</p>
            </div>
            <p className="subpara-text">{element.desc}</p>
            <p className="subpara-text italicstyling">{element.responsibilityHead}</p>
            <ul className="padding-top-0" type="disc">
                {element.responsibilities.map(el => {
                    return <li key={uuidv4()} className="subpara-text">{el}</li>
                })}
            </ul>
            {
                (element.contactName !== '' || element.contactPhone !== '') ?
                <>
                    <div className="flex-container">
                        <span className="subpara-text italicstyling">Contact:&nbsp;</span>
                        <span className="subpara-text">&nbsp;{element.contactName}</span>
                        <span className="subpara-text">{(element.contactName !== '' && element.contactPhone !== '') && ' - '}</span>
                        <span className="subpara-text">&nbsp;{element.contactPhone}</span> 
                    </div>
                </>
                : ''
            }
        </div>
    );
}


function Experience(props) {
    return (
        <>
            <p className="heading-text mt-6">EXPERIENCE</p>
            {
                props.experience.map(element => {
                    return <SingleExperience key={uuidv4()} {...element}/>
                })
            }
        </>
    )
}

export default Experience
